import React, { lazy, useEffect } from 'react';

import { Route, Routes, Navigate, useParams } from 'react-router-dom';
import Header from './header';
import Footer from './footer';
import Suspense from '../../../ui-components/suspense';

/* Pages */
const TermsOfUse = lazy(() => import('../../legalpages/termsofuse'));
const PrivacyPolicy = lazy(() => import('../../legalpages/privacypolicy'));
const CustomerAgreement = lazy(() => import('../../legalpages/customeragreement'));
const DataFormat = lazy(() => import('../../legalpages/dataformat'));
const AboutUs = lazy(() => import('./aboutus'));
const Home = lazy(() => import('./home'));
const GCOwner = lazy(() => import('./gc-owner'));
const GCSelfPerform = lazy(() => import('./gc-self-perform'));
const TradeContractor = lazy(() => import('./trade-contractor'));
const Suppliers = lazy(() => import('./suppliers'));
const SmallBusiness = lazy(() => import('./small-business'));
const Pricing = lazy(() => import('./pricing'));
const Tutorials = lazy(() => import('./tutorials'));
const Contact = lazy(() => import('./contact'));
const QuickStart = lazy(() => import('./gc-quickstart'));
const Concrete = lazy(() => import('./landing/div-03-concrete'));
const Masonry = lazy(() => import('./landing/div-04-masonry'));
const BuildingFraming = lazy(() => import('./landing/div-06-building-framing'));
const RoofingInsulation = lazy(() => import('./landing/div-07-roofing-insulation'));
const InteriorSpecialty = lazy(() => import('./landing/div-09-interior-specialty'));
const Mechanical = lazy(() => import('./landing/div-23-mechanical'));
const SubmittalTemplates = lazy(() => import('./submittal-templates'));
const SignUp = lazy(() => import('./sign-up'));
const TurnerPage = lazy(() => import('./turner'));
import PhoneCall from './PhoneCall';

import getQueryVariable from '../../../ui-components/js/getQueryVariable';

/* Dialogs { Forgot, Recover, EChange, About, Login } */
import { all as Dialogs, suspense } from '../../js/dialogs';

let page = '';
/* PublicWrapper */
function PublicWrapper(props) {
  useEffect(() => {
    let Dlg = Dialogs[props.dialog || ""];

    if (Dlg) {
      window.modal(suspense(Dlg), {routeParams: props.routeParams});
    }
  }, []);

  if (page !== props.page) {
    page = props.page;

    window.buildsite.logPageView();
    let container = document.querySelector('.mainWrapper');
    container && container.scroll(0, 0);
  }


  let MainClass = props.main;
  return (
    <>
      <PhoneCall />
      <Header page={props.page || ""} />
      <MainClass />
      <Footer />
    </>
  );
}

// /recovery/:code/:type is the only route that reads route params directly
// (it used to receive them via the v5 render-prop's `p.match.params`)
function RecoveryWrapper() {
  const params = useParams();
  return <PublicWrapper page="home" main={Home} dialog="Recover" routeParams={params} />;
}

/* PublicContainer */
export default class PublicContainer extends React.Component {
  componentDidMount() {
    window.buildsite.logPageView();
    ["email_address", "redirect_url"].forEach(field => {
      let zz = getQueryVariable(field);
      if (zz) window.buildsite[field] = zz;
    });
    buildsite.api().on("refresh", this.goRefresh);
  }

  componentWillUnmount() {
    buildsite.api().removeListener("refresh", this.goRefresh);
  }

  goRefresh = () => {
    console.warn("PublicContainer got refresh event");
  }

  render() {
    return (
      <Suspense>
        <div className="mainWrapper">
          <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />

            <Route path="/home"              element={<PublicWrapper page="home"              main={Home}  />} />
            <Route path="/login"             element={<PublicWrapper page="home"              main={Home}  dialog="Login" />} />
            <Route path="/interstitial"      element={<PublicWrapper page="home"              main={Home}  dialog="Interstitial" />} />
            <Route path="/sign-up"           element={<PublicWrapper page="sign-up"           main={SignUp} />} />
            <Route path="/emailchange/:id"   element={<PublicWrapper page="login"             main={Home} dialog="EChange" />} />
            <Route path="/recovery/:code/:type"    element={<RecoveryWrapper />} />

            <Route path="/aboutus"           element={<PublicWrapper page="aboutus"           main={AboutUs}   />} />

            <Route path="/pricing/enterprise" element={<Navigate to="/pricing" replace />} />

            <Route path="/pricing/:type"                      element={<PublicWrapper page="pricing"  main={Pricing}   />} />
            <Route path="/pricing"                      element={<PublicWrapper page="pricing"  main={Pricing}   />} />

            <Route path="/features" element={<Navigate to="/gcs-owners" replace />} />
            <Route path="/gcs-owners"      element={<PublicWrapper page="gcs-owners"      main={GCOwner}  />} />
            <Route path="/gc-self-perform"     element={<PublicWrapper page="gc-self-perform"     main={GCSelfPerform}  />} />
            <Route path="/trade-contractors"     element={<PublicWrapper page="trade-contractors"     main={TradeContractor}  />} />
            <Route path="/suppliers"     element={<PublicWrapper page="suppliers"     main={Suppliers}  />} />
            <Route path="/small-business"     element={<PublicWrapper page="smallBusiness"     main={SmallBusiness}  />} />


            <Route path="/submittal-templates"   element={<PublicWrapper page="submittal-templates"  main={SubmittalTemplates} />} />
            <Route path="/tutorials"         element={<PublicWrapper page="tutorials"         main={Tutorials} />} />

            <Route path="/termsofuse"        element={<PublicWrapper page="terms"             main={TermsOfUse}        />} />
            <Route path="/privacypolicy"     element={<PublicWrapper page="policy"            main={PrivacyPolicy}     />} />
            <Route path="/customeragreement" element={<PublicWrapper page="customeragreement" main={CustomerAgreement} />} />
            <Route path="/dataformat"        element={<PublicWrapper page="dataformat"        main={DataFormat}        />} />
            <Route path="/contact"           element={<PublicWrapper page="contact"           main={Contact}           />} />
            <Route path="/sub-quick-start" element={<Navigate to="/quick-start" replace />} />
            <Route path="/gc-quick-start" element={<Navigate to="/quick-start" replace />} />
            <Route path="/quick-start"    element={<PublicWrapper page="quick-start"    main={QuickStart}        />} />
            <Route path="/intro/div-03-concrete"           element={<PublicWrapper page="concrete"              main={Concrete}       />} />
            <Route path="/intro/div-04-masonry"            element={<PublicWrapper page="masonry"               main={Masonry}        />} />
            <Route path="/intro/div-06-building-framing"   element={<PublicWrapper page="building-framing"      main={BuildingFraming}/>} />
            <Route path="/intro/div-07-roofing-insulation" element={<PublicWrapper page="roofing-insulation"    main={RoofingInsulation}/>} />
            <Route path="/intro/div-09-interior-specialty" element={<PublicWrapper page="interior-specialty"    main={InteriorSpecialty}/>} />
            <Route path="/intro/div-23-mechanical"         element={<PublicWrapper page="mechanical"            main={Mechanical}     />} />
            <Route path="/intro/misc" element={<Navigate to="/intro/div-06-building-framing" replace />} />
            <Route path="/intro/turner"                    element={<PublicWrapper page="turner"                main={TurnerPage}     />} />
          </Routes>
        </div>
      </Suspense>
    );
  }
}
